import {curry, compose as C, map as m, juxt, reduce, identity, values, max, min, always} from "ramda";
export const {round, pow, abs, sqrt} = Math;
export const r = curry((d,x) => round(x*pow(10,d))/pow(10,d));
export const normalize = (data,start_zero) => C(
    ([xs,highest,lowest]) => m(x => (x-lowest)/(highest-lowest),xs),
    juxt([
        identity,
        C(reduce(max,0),values),
        C(start_zero ? always(0) : identity,reduce(min,Infinity),values)
    ]))(data)